// extracted by mini-css-extract-plugin
export default {"addCustomValue":"AddCustomValue_addCustomValue__WHeqF","buttonsCustomValues":"AddCustomValue_buttonsCustomValues__ETRNY"};